import axios from "axios";
import { configJson } from "../services/firebaseUtils";

const api = axios.create({
  baseURL: configJson.API_HOST_NODE,
});

export default api;
